module.exports = __webpack_public_path__ + "static/media/KaTeX_SansSerif-Bold.f28c4fa2.woff";